import { render, staticRenderFns } from "./GeneralSampleInformation.vue?vue&type=template&id=970f77ae&scoped=true"
import script from "./GeneralSampleInformation.vue?vue&type=script&lang=js"
export * from "./GeneralSampleInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970f77ae",
  null
  
)

export default component.exports